import React, { useEffect, useState } from "react";

const Msbanner = () => {
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    // Trigger animation on mount
    setTimeout(() => setAnimate(true), 300);
  }, []);

  const bannerStyles = {
   // marginTop: "60px",
    width: "100%",
    height: "90vh",
    backgroundImage: "url('/image/first.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center center",
    display: "flex",
    justifyContent: "flex-start",   
    alignItems: "center",  
    color: "white",
    position: "relative",
    overflow: "hidden",
    paddingLeft: "5%",  
  };

  const contentStyles = {
    maxWidth: "600px",
    textAlign: "left",
  };

  const headingStyles = {
    fontSize: "32px",
    margin: 0,
    lineHeight: 1.2,
    fontWeight: "bold",
    opacity: animate ? 1 : 0,
    transform: animate ? "translateY(0)" : "translateY(50px)",
    transition: "all 1s ease",
    color:"white",
    letterSpacing:"0px",
  };

  const paragraphStyles = {
    fontSize: "26px",
    marginTop: "1rem",
    opacity: animate ? 1 : 0,
    transform: animate ? "translateY(0)" : "translateY(50px)",
    transition: "all 1.5s ease",
    textAlign:"justify",
  };

  return (
    <div style={bannerStyles}>
      <div style={contentStyles}>
        <h1 style={headingStyles}>Innovative Multimedia Solutions</h1>
        <p style={paragraphStyles}>
          Empowering businesses with interactive design, video, and digital experiences.
        </p>
      </div>
    </div>
  );
};

export default Msbanner;
